<template>
  <section class="prices-outro" ref="root">
    <div class="prices-outro__inner" :class="{ 'prices-outro__inner_visible': inView }">
      <div class="prices-outro__callout">
        <span class="prices-outro__icon" aria-hidden="true" v-html="iconSvg" />
        <div class="prices-outro__content">
          <p class="prices-outro__line prices-outro__line_lead">
            Каждая картина становится не просто арт-объектом,<br />
            <strong>а персональным символом целей и уровня.</strong>
          </p>
          <p class="prices-outro__line">
            Все картины создаются с вниманием к деталям и смыслу.<br />
            Подходят для дома, офиса и в подарок.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'PricesOutro',
  setup() {
    const root = ref(null)
    const inView = ref(false)
    let observer = null

    const iconSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15 9 22 9 17 14 19 21 12 17 5 21 7 14 2 9 9 9"/></svg>`

    onMounted(() => {
      observer = new IntersectionObserver(
        ([e]) => { if (e.isIntersecting) inView.value = true },
        { threshold: 0.2 }
      )
      if (root.value) observer.observe(root.value)
    })
    onUnmounted(() => observer?.disconnect())

    return { root, inView, iconSvg }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";

$dur: 0.7s;
$ease: cubic-bezier(0.22, 1, 0.36, 1);

.prices-outro {
  padding: 0 $gap 100px;

  @media (max-width: $breakpoint-mobile) {
    padding: 0 $gap 72px;
  }

  &__inner {
    max-width: $container-max;
    margin: 0 auto;
  }

  &__callout {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    padding: 28px 32px;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.02) 100%);
    border-left: 4px solid $color-accent-teal;
    border-radius: 0 12px 12px 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    opacity: 0;
    transform: translateY(20px);
    transition: opacity $dur $ease, transform $dur $ease;

    .prices-outro__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }

    @media (max-width: $breakpoint-mobile) {
      flex-direction: column;
      gap: 16px;
      padding: 24px 20px;
    }
  }

  &__icon {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    color: $color-accent-teal;

    :deep(svg) {
      width: 26px;
      height: 26px;
    }
  }

  &__content {
    flex: 1;
  }

  &__line {
    font-size: clamp(16px, 1.7vw, 18px);
    line-height: 1.6;
    color: $color-text-muted;
    margin: 0 0 16px;

    &:last-child {
      margin-bottom: 0;
      transition-delay: 0.1s;
    }

    opacity: 0;
    transform: translateY(12px);
    transition: opacity $dur $ease, transform $dur $ease;

    .prices-outro__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }

    &_lead {
      color: $color-text;
      font-weight: 500;

strong {
      font-weight: 800;
      color: $color-accent-teal;
    }
    }
  }
}
</style>
